import React from 'react';
import { CircularProgress } from '@chakra-ui/react';

export default function Loader() {
  return <CircularProgress capIsRound isIndeterminate mt={4} size='30px' thickness='8px' color='black' />;
}
